var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',[_c('div',{staticClass:"single-date-picker__calendar-week-header"},[_vm._v(" "+_vm._s(_vm.day)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }